
<template>
    <ListDialog ref="ReceivePaymentScheduledDialog" :title="$parent.formatTitle('入金予定表')" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="onReportGenerate" :isRemainAfterExec="true" >
      <template slot="header" slot-scope = "{editor}">
	    <AutoComplete title="帳票テンプレート" :editor="editor" :value.sync="reportTemplate" :required="true" query="ReceivePaymentScheduledReportTemplateQuery" tooltip="出力する帳票のテンプレートを選択します。【帳票テンプレート】の【帳票タイプ】が【入金予定】のデータを選択でき、初期値は×で消してから変更が可能です。" />
	    <AtcCounterpart title="取引先" :editor="editor" :value.sync="counterpart" :needsCustomer="true" tooltip="ここで取引先を選択をすると、選択した取引先だけのデータを出力する事ができます。選択しない場合はすべての取引先のデータが出力できます。" />
      <AtcSegment title="部門" :editor="editor" :value.sync="segment" tooltip="ここで部門を選択をすると、選択した部門だけのデータを出力する事ができます。選択しない場合はすべての部門のデータが出力できます。" />
      <ComboBox title="伝票種別" :value.sync="slipType" :showDefault="false" :list="hasLicenseCurrency?'searchReceivePaymentFlags':'receivePaymentFlagsNoLicenseCurrency'" tooltip="ここで伝票種別を選択すると、選択した伝票種別だけのデータを出力することができます。選択しない場合はすべての伝票種別のデータが出力できます。" />
      <CheckBox title="残高ゼロを含める" :editor="editor" :value.sync="isIncludeBalanceZero" list="isInclude" tooltip="未入金残高がゼロのデータを帳票に表示するか否かを選択します。" />
      <Calendar title="入金予定日(From)" :editor="editor" :value.sync="startDate" :deletable="false" :required="true" :autoEntry="true" :dateFlag.sync="startDateFlag"  tooltip="データを帳票に出力をする入金予定日の開始日を指定します。ここで指定した日付以前のデータは出力対象外となります。" />
	    <Calendar title="入金予定日(To)" :editor="editor" :value.sync="endDate" :deletable="false" :required="true"  :autoEntry="true" :dateFlag.sync="endDateFlag" tooltip="データを帳票に出力をする入金予定日の終了日を指定します。ここで指定した日付以降のデータは出力対象外となります。" />
      <RadioButton title="出力形式" :editor="editor" :value.sync="onExcelExport" list="reportStyles"/>           
      </template>
      <button slot="footer_buttons" type="button" class="btn btn-info" :disabled="$parent.favoriteDisabled" @click="$parent.onShowFavorite">{{$parent.favoriteLoaded? 'お気に入りを更新':'お気に入りに追加'}}</button>
      <button slot="footer_buttons" type="button" class="btn btn-secondary btn_delete" :disabled="$parent.favoriteDisabled" @click="$parent.onDeleteFavorite" v-if="$parent.favoriteLoaded"><i class="material-symbols-outlined small valign">delete</i></button>               
    </ListDialog> 
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptReceivePaymentScheduled extends Vue {

  // 入金予定表用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  
  public counterpart: Common.Counterpart = null;
  public segment: Common.Segment = null;
  public slipType:number = null;
  public isIncludeBalanceZero:boolean = false;
  public startDate: Date = null;
  public endDate: Date = null;
  public hasLicenseCurrency: boolean = false;
  public onExcelExport :boolean = false;
  public startDateFlag : Common.dateFlags = Common.dateFlags.default;
  public endDateFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
   if ((this.$parent as any).favoriteLoaded == false){         
    var query: Common.ReceivePaymentScheduledReportTemplateQuery = new Common.ReceivePaymentScheduledReportTemplateQuery();
    this.$api.execute(query).then(obj => {
      var items: Common.ReportTemplate[] = new Array();
      items = (obj as Common.LoadResult).result;
      if (items.length > 0) this.reportTemplate = items[0];
    });
   }
    this.slipType = 128;
    this.startDate = new Date().getCalendarDate();
    this.endDate = new Date().getCalendarDate();
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    (this.$refs.ReceivePaymentScheduledDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.ReceivePaymentScheduledReportQuery = new Common.ReceivePaymentScheduledReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.counterpart = this.counterpart;
    query.segment = this.segment;
    query.slipType = this.slipType;
    query.isIncludeBalanceZero = this.isIncludeBalanceZero;
    query.startDate = this.startDate;
    query.endDate = this.endDate;
    query.onExcelExport = this.onExcelExport;
    this.$api.download(query);
  }
}
</script>
